import { Grid, Switch } from '@mui/material'
import SoftBox from 'components/SoftBox'
import React, { useState } from 'react'
import { useAgencyInfo } from "context/agency";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import CopyToClipboard from "react-copy-to-clipboard";
import env from "config/env";
import SoftTypography from 'components/SoftTypography';
import FormField from "layouts/pages/account/components/FormField";
import { useUploadImage } from "hook/services";

function General({ handleImage, handleSubmit , loading}) {
  const [agency] = useAgencyInfo();
  const customUrlDomain = env.ACCOUNT_LEVEL_URL
  const SERVER_IP = env.SERVER_IP;
  const [domainupdate, setDomainupdate] = useState(false);
  const [DefaultImage, setDefaultImage] = useState(agency?.Customization?.default_image || true);
  const [custom_color, setcustom_color] = useState(agency?.Customization?.custom_color || false);
  const [copy, setcopy] = useState(false);
  const [default_image_switch, setdefault_image_switch] = useState(false);
  const [ghl_connect_logo, setGhl_connect_logo] = useState(agency?.Customization?.ghl_connect_logo || "");
  const [logo, setlogo] = useState(agency?.Customization?.logo || "");
  const [openWhitelabelModal, setopenWhitelabelModal] = useState(false);
  const url = agency?.domain
    ? `https://${agency.domain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`
    : `${customUrlDomain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`;
  const handlecopy = () => {
    setcopy(true);

    setTimeout(() => {
      setcopy(false);
    }, 2000);
  };
  const uploadImage = useUploadImage();
  const handleImageinner = async (e, type) => {
    const response = await uploadImage({
      file: e.target.files[0],
      desiredPath: `design/logo/image`,
    });
    if (type == "logo") {
      setlogo(response.response.data);
    } else if (type == "ghl_connect_logo") {
      setGhl_connect_logo(response.response.data);
    }
    handleImage(response.response.data, type)
  };
  return (
    <div>
      <SoftBox component="form" onSubmit={handleSubmit}>
        <Grid container spacing={3} rowSpacing={2} paddingX={3} paddingBottom={4}>
          <Grid item xs={12}>
            <SoftTypography variant="h5" style={{ marginBottom: '8px' }}>Logo</SoftTypography>
          </Grid>
          <Grid item xs={12} display={"flex"} alignItems="center" style={{ padding: 0 }}>
            <div className='custom-upload-pad'>
              {logo ? (
                <img
                  src={logo}
                  alt="Logo"
                  width={100}
                  height={50}
                  style={{
                    width: "100%",
                    height: "100%"
                  }}
                />
              ) :
                <SoftButton className='img-center' variant="outlined" component="label" color="dark">
                  <div>
                    <svg width="100" height="30" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.38444 3.98444L4.99555 5.68667L4.58611 5.31056L6.66222 2.77778L8.74722 5.325L8.32889 5.69444L6.94 3.98556V8.33333H6.38444V3.98444ZM10.2778 9.44444H3.05556C1.67722 9.44444 0.555556 8.32333 0.555556 6.94444C0.555556 5.73444 1.41944 4.70111 2.61 4.48667L3.04278 4.40889L3.06667 3.97056C3.16944 2.055 4.75056 0.555556 6.66667 0.555556C8.58278 0.555556 10.1639 2.055 10.2656 3.97056L10.29 4.40889L10.7233 4.48667C11.9133 4.70111 12.7778 5.73444 12.7778 6.94444C12.7778 8.32333 11.6561 9.44444 10.2778 9.44444ZM10.8211 3.94C10.7033 1.745 8.89222 0 6.66667 0C4.44111 0 2.62944 1.745 2.51167 3.94C1.08389 4.19722 0 5.44333 0 6.94444C0 8.63167 1.36833 10 3.05556 10H10.2778C11.965 10 13.3333 8.63167 13.3333 6.94444C13.3333 5.44333 12.2494 4.19722 10.8211 3.94Z" fill="#757575" />
                    </svg>
                  </div>
                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    name="logo"
                    onChange={(e) => handleImageinner(e, "logo")}
                  />
                </SoftButton>
              }
            </div>
            {logo && <div className='buttonupload' style={{ marginLeft: "10px", marginTop: "100px" }}>
              <label
              >
                <div>
                  <svg width="14" height="20" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.38444 3.98444L4.99555 5.68667L4.58611 5.31056L6.66222 2.77778L8.74722 5.325L8.32889 5.69444L6.94 3.98556V8.33333H6.38444V3.98444ZM10.2778 9.44444H3.05556C1.67722 9.44444 0.555556 8.32333 0.555556 6.94444C0.555556 5.73444 1.41944 4.70111 2.61 4.48667L3.04278 4.40889L3.06667 3.97056C3.16944 2.055 4.75056 0.555556 6.66667 0.555556C8.58278 0.555556 10.1639 2.055 10.2656 3.97056L10.29 4.40889L10.7233 4.48667C11.9133 4.70111 12.7778 5.73444 12.7778 6.94444C12.7778 8.32333 11.6561 9.44444 10.2778 9.44444ZM10.8211 3.94C10.7033 1.745 8.89222 0 6.66667 0C4.44111 0 2.62944 1.745 2.51167 3.94C1.08389 4.19722 0 5.44333 0 6.94444C0 8.63167 1.36833 10 3.05556 10H10.2778C11.965 10 13.3333 8.63167 13.3333 6.94444C13.3333 5.44333 12.2494 4.19722 10.8211 3.94Z" fill="#757575" />
                  </svg>
                </div>
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  name="logo"
                  onChange={(e) => handleImageinner(e, "logo")}
                />
              </label>
            </div>}
          </Grid>
          <SoftTypography variant="p" className="roboto-family" style={{ fontSize: '14px', marginTop: '4px' }}>
            Recommended: 5:1 ratio. 1MB size.
          </SoftTypography>
          <Grid item xs={12} className='zeroBtmP' style={{ marginTop: '20px' }}>
            <SoftTypography variant="h5">Body and Top bar Styling</SoftTypography>
          </Grid>
          {/* <Grid item xs={4}>
            <FormField
              defaultValue={agency?.Customization?.body_bg}
              className="color-input"
              label="Body Background"
              name="body_bg"
              inputProps={{ type: "color" }}
            />
          </Grid> */}
          <Grid item xs={4} className='px-2'>
            <FormField
              defaultValue={agency?.Customization?.home_m_title}
              label="Home Meta Title"
              name="home_m_title"
            />
          </Grid>
          <Grid item xs={4} className='px-2'>
            <FormField
              defaultValue={agency?.Customization?.home_m_description}
              label="Home Meta Description"
              name="home_m_description"
            />
          </Grid>

          <Grid item xs={4} className='px-2'>

            {/* <div style={{ margin: "0px 0px 0px 18px", padding: "28px 0px 0px 1px" }} className='d-flex justify-content-between'>

              <div>
                <p style={{ fontSize: "15px" }}> Hero Background</p>
                <p style={{ fontSize: "15px" }}> use Defualt image :  </p>
              </div>
              <div style={{ margin: "15px 0px 0px 13px" }}>
                <Switch checked={default_image_switch} onChange={() => setdefault_image_switch(!default_image_switch)} />
              </div>

            </div> */}

          </Grid>
          <Grid item xs={4} className='px-2' >
            <FormField
              defaultValue={agency?.Customization?.topbar_bg}
              className="color-input"
              label="Topbar Background"
              name="topbar_bg"
              inputProps={{ type: "color" }}
            />
          </Grid>
          <Grid item xs={4} className='px-2'>
            <FormField
              defaultValue={agency?.Customization?.topbar_text}
              className="color-input"
              label="Topbar Text"
              name="topbar_text"
              inputProps={{ type: "color" }}
            />
          </Grid>
          <Grid item xs={4} className='px-2'>
            <FormField
              defaultValue={agency?.Customization?.topbar_active_text}
              className="color-input"
              label="Topbar Active option Text"
              name="topbar_active_text"
              inputProps={{ type: "color" }}
            />
          </Grid>

          <Grid item xs={12} className='zeroBtmP' style={{ marginTop: '20px' }}>
            <SoftTypography variant="h5">Buttons Styling</SoftTypography>
          </Grid>
          <Grid item xs={4} className='px-2'>
            <FormField
              defaultValue={agency?.Customization?.button_bg}
              className="color-input"
              label="Buttons Background"
              name="button_bg"
              inputProps={{ type: "color" }}
            />
          </Grid>
          <Grid item xs={4} className='px-2'>
            <FormField
              defaultValue={agency?.Customization?.button_text}
              className="color-input"
              label="Buttons Text"
              name="button_text"
              inputProps={{ type: "color" }}
            />
          </Grid>
          <Grid item xs={4} className='px-2'>
            <FormField
              defaultValue={agency?.Customization?.button_border}
              className="color-input"
              label="Buttons Border"
              name="button_border"
              inputProps={{ type: "color" }}
            />
          </Grid>

          <Grid item xs={12} className='zeroBtmP' style={{ marginTop: '20px' }}>
            <SoftTypography variant="h5">Social Links</SoftTypography>
          </Grid>
          <Grid item xs={6} Soft={6} className='px-2'>
            <FormField
              label="Facebook"
              placeholder="Facebook"
              name="facebook"
              defaultValue={agency?.Customization?.social_urls?.facebook}
            />
          </Grid>
          <Grid item xs={6} Soft={6} className='px-2'>
            <FormField
              label="Instagram"
              placeholder="Instagram"
              name="instagram"
              defaultValue={agency?.Customization?.social_urls?.instagram}
            />
          </Grid>
          <Grid item xs={6} Soft={6} className='px-2'>
            <FormField
              label="LinkedIn"
              placeholder="LinkedIn"
              name="linkedin"
              defaultValue={agency?.Customization?.social_urls?.linkedin}
            />
          </Grid>
          <Grid item xs={6} Soft={6} className='px-2'>
            <FormField
              label="Twitter"
              placeholder="Twitter"
              name="twitter"
              defaultValue={agency?.Customization?.social_urls?.twitter}
            />
          </Grid>

          <Grid item xs={12} className='zeroBtmP' style={{ marginTop: '20px' }}>
            <SoftTypography variant="h5">Customer Info</SoftTypography>
          </Grid>
          <Grid item xs={12} sm={4} className='px-2'>
            <FormField
              label="Email"
              placeholder="example@email.com"
              inputProps={{ type: "email" }}
              name="email"
              defaultValue={agency?.Customization?.customer_info?.email}
            />
          </Grid>
          <Grid item xs={12} sm={4} className='px-2'>
            <SoftTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Name
            </SoftTypography>
            <SoftInput
              label="Name"
              placeholder="Enter NAme"
              inputProps={{ type: "name" }}
              name={"name"}
              defaultValue={agency?.Customization?.customer_info?.name}
            />
          </Grid>
          <Grid item xs={12} sm={4} className='px-2'>
            <FormField
              label="Phone Number"
              placeholder="+40 735 631 620"
              inputProps={{ type: "phone" }}
              name={"phone_number"}
              defaultValue={agency?.Customization?.customer_info?.phone_number}
            />
          </Grid>

          <Grid item xs={12} className='zeroBtmP' style={{ marginTop: '20px' }}>
            <SoftTypography variant="h5">White Labeling</SoftTypography>
          </Grid>
          <Grid item xs={12} className='px-2'>
            <SoftTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Enter your Domain
            </SoftTypography>
            <SoftInput
              placeholder="domain"
              name="domain"
              defaultValue={agency?.domain}
              onChange={() => setDomainupdate(true)}
            />
            <input type="hidden" name="domain_update" value={domainupdate} />
          </Grid>
          <Grid item xs={12} className='px-2'>
            <label>Enter G-TAG</label>
            <textarea
              placeholder="TAG"
              name="gtag"
              defaultValue={agency?.Customization?.gtag}
              rows={6}
              style={{ width: "100%",borderRadius:"5px",border:"gray 1px solid",padding:"10px 20px" }}
            />
            
          </Grid>

        
          <Grid item xs={12} className='px-2' display="flex" justifyContent={"space-between"}>
          <SoftButton className="bg-dark" color="dark" type="button" onClick={() => setopenWhitelabelModal(true)}>
              Domain Connection Info
            </SoftButton>
            <SoftButton className="bg-dark" color="dark" type="submit"
              disabled={loading} // Disable the button while loading
              style={{
                cursor: loading ? 'no-drop' : 'pointer', // Change cursor to 'not-allowed' (red circle) while loading
              }}
            >
              update
            </SoftButton>
            
          </Grid>
          {openWhitelabelModal &&
            <div className="modal-zz-confirm" onClick={() => setopenWhitelabelModal(false)}>

              <div className="scrollable-modal-content bg-white  rounded" style={{ border: "1px solid black ", position: "relative" }}>
                <h2 className='text-center font-14'>  Connect white label domain
                </h2>
                <span className='crossison'>X</span>
                <div className='list-model0' >
                  <p>Connect your own domain to the system (without https://) maybetech.yourdomain.com</p>
                  <p> You can use any domain you own or you can create a sub-domain like
                    maybetech.yourdomain.com to get white-labeled access to the platform.
                  </p>
                  <ul>
                    <li className='listtext'>
                      <b>1.</b> Refer to your domain registrar&apos;s control panel, choose desired domain
                      zone.
                    </li>

                    <li className='listtext'>  <b>2.</b>Create a record of{" "}
                      <u>
                        <b>ANAME</b>
                      </u>{" "}
                      type, enter your domain/subdomain name and point it to{" "}
                      <u>
                        <b>{SERVER_IP}</b>
                      </u> </li>
                    <li className='listtext'> <b>3.</b> We will do the rest! </li>
                  </ul>
                </div>

              </div>
            </div>


          }

        </Grid>
      </SoftBox>
    </div >
  )
}

export default General
